import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { filterEmptyFields } from '../../utils/formUtils';
import {
  Dialog,
  Button,
  Backdrop,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '../../components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { AsyncSelectField } from 'components/Fields';
import { useNotification } from 'hooks/useNotification';
import { channelAPI } from 'services/admin';

// let users = [];
// let channels = []
// const canais = [
//   "5968720c-56dc-4b56-8b44-ecde91e2d04e",
//   "Sesc Digital",
//   "Av Paulista Digital",
//   "Informação e educação popular",
// ];

function ModalChannel(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const [isLoadingModalConfirmation, setIsLoadingModalConfirmation] =
    useState(false);
  const { setNotify } = useNotification();
  const { showConfirmationButton } = useState(true);

  const {
    formState: { isDirty, isValid },
    handleSubmit,
    reset,
    getValues,
    setValue,
    watch,
    control,
  } = useForm({ mode: 'onBlur' });

  async function postData(bodyData) {
    setIsLoading(true);
    // bodyData.createdBy = {"userId": session.getIdToken().payload.sub, "name": session.getIdToken().payload.username} //TODO: verificar se manda o name do cognito
    // bodyData.updatedBy = {"userId": session.getIdToken().payload.sub, "name": session.getIdToken().payload.name} //TODO: verificar se manda o name do cognito
    const data = {
      body: bodyData,
    };

    return channelAPI
      .post(data)
      .then(resp => {
        setNotify({
          isOpen: true,
          message: `Canal criado com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        props.getChannels();
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function putData(bodyData) {
    setIsLoading(true);
    const data = {
      body: bodyData,
    };

    return channelAPI
      .put(`/${props.channel.id}`, data)
      .then(resp => {
        setNotify({
          isOpen: true,
          message: `Canal atualizado com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        props.getChannels();
      })
      .catch(error => {
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
        console.log(error);
      });
  }
  async function deleteData() {
    setIsLoadingModalConfirmation(true);

    channelAPI
      .del(`/${props.channel.id}`)
      .then(resp => {
        setNotify({
          isOpen: true,
          message: `Canal "${props.channel.name}" removido!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        setIsLoadingModalConfirmation(false);
        setConfirmDialogAction({ isOpen: false });
        props.onClose();
        props.getChannels();
      })
      .catch(error => {
        console.log(error);
        setIsLoadingModalConfirmation(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: `${parseJson.message}: O canal "${props.channel.name}" tem ${props.channel.linkedVideosCount} video(s), ${props.channel.linkedCollectionsCount} coleção(ões) e ${props.channel.linkedUsersCount} usuário(s) associados, remova os vinculos para prosseguir com a remoção do canal.`,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  useEffect(() => {
    //On Modal Open
    // setSelectedName(props.channel.name ? props.channel.name : '')
    // setSelectedLink(props.channel.officialWebPageUrl ? props.channel.officialWebPageUrl : '')

    if (props.open === true) {
      setValue('name', props.channel.name ? props.channel.name : '');
      setValue(
        'officialWebPageUrl',
        props.channel.officialWebPageUrl ? props.channel.officialWebPageUrl : ''
      );
      setValue(
        'users',
        props.channel.linkedUsers
          ? props.channel.linkedUsers.map(user => ({
              value: user.userId,
              label: user.name,
            }))
          : []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  const onSubmit = data => {
    // Remove fields with empty values
    const formValues = getValues();
    let filteredFormValues = filterEmptyFields(formValues);

    if (filteredFormValues.users)
      filteredFormValues.users = filteredFormValues.users.map(user => ({
        userId: user.value,
      })); //TODO o user e o channel estao como o nome, mas o back espera o id deles
    if (props.action === 'edit') {
      putData(filteredFormValues).then(() => {
        closeModal();
      });
    } else if (props.action === 'create') {
      postData(filteredFormValues)
        .then(() => {
          // Reset all fields after post
          closeModal();
          // setActive(undefined)
        })
        .catch(error => {
          console.log(error);
          //TODO: o que acontece se der erro na inserção?
        });
    }
  };

  function closeModal() {
    reset();
    props.onClose();
  }
  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 12,
            }}>
            <DialogTitle
              style={{ lineHeight: 0, color: 'rgba(16, 24, 40, 1)' }}>
              {props.action === 'edit' ? 'Editar canal' : 'Criar canal'}
            </DialogTitle>
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}>
            <CloseIcon />
          </IconButton>

          <Typography
            style={{ paddingRight: 24, paddingTop: 4, paddingLeft: 24 }}>
            Preencha as informações de um novo canal.
          </Typography>
          <DialogContent>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">40 caracteres</label>
                <InputLabel className="form-label" htmlFor="name">
                  Nome
                </InputLabel>
              </div>
              <Controller
                name={'name'}
                control={control}
                rules={{
                  required: 'O nome é obrigatório',
                  minLength: { value: 3, message: 'Mínimo de 3 caracteres' },
                  maxLength: { value: 40, message: 'Máximo de 40 caracteres' },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error },
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o nome"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.channel.deleted === true
                        ? true
                        : props.channel.deleted === 'true'
                          ? true
                          : false
                    }
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formLink">
              <InputLabel className="form-label" htmlFor="officialWebPageUrl">
                Link da página oficial
              </InputLabel>
              <Controller
                name={'officialWebPageUrl'}
                control={control}
                rules={{
                  minLength: { value: 3, message: 'Mínimo de 3 caracteres' },
                  maxLength: { value: 40, message: 'Máximo de 40 caracteres' },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedLink(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Digite o link"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.channel.deleted === true
                        ? true
                        : props.channel.deleted === 'true'
                          ? true
                          : false
                    }
                  />
                )}
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              style={{ height: 'auto' }}
              controlId="formUser">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="users">
                Usuários vinculados ({watch('users')?.length || 0})
              </InputLabel>
              <AsyncSelectField
                id="users"
                name="users"
                isMulti
                placeholder="Buscar..."
                isDisabled={
                  props.channel.deleted === true
                    ? true
                    : props.channel.deleted === 'true'
                      ? true
                      : false
                }
                openMenuOnClick={
                  props.channel.deleted === true
                    ? false
                    : props.channel.deleted === 'true'
                      ? false
                      : true
                }
                control={control}
                url="/admin/users?performance=true&limit=10&name=#name&sortBy=name&offset=#offset"
                responseKey="userList"
                isOptionDisabled={option => option.role === 'ADMIN'}
              />
            </Form.Group>
          </DialogContent>
          <DialogActions style={{ padding: '0 24px 24px' }}>
            {props.action === 'edit' && (
              <Button
                style={{
                  color: 'rgba(52, 64, 84, 1)',
                  borderRadius: 8,
                  background: 'rgba(255, 255, 255, 1)',
                  borderColor: 'rgba(208, 213, 221, 1)',
                  padding: '10px 18px',
                  marginLeft: 12,
                  pointerEvents:
                    props.channel.deleted === true
                      ? 'none'
                      : props.channel.deleted === 'true'
                        ? 'none'
                        : '',
                }}
                onClick={() =>
                  setConfirmDialogAction({
                    isOpen: true,
                    title: `Remover ${props.channel.name}?`,
                    subTitle: `Você está removendo o canal "${props.channel.name}" permanentemente. Clique remover para confirmar.`,
                    confirmTextButton: 'Remover',
                    color: 'error',
                    children: (
                      <div className="modalRemoveItem">
                        <DeleteOutlineOutlinedIcon
                          color="error"
                          fontSize="8px"
                        />
                      </div>
                    ),
                    onConfirm: () => {
                      deleteData();
                    },
                    showConfirmationButton: { showConfirmationButton },
                    closeTextButton: 'Cancelar',
                  })
                }
                variant="contained"
                className={
                  props.channel.deleted === true
                    ? 'disabled_inactive_button'
                    : props.channel.deleted === 'true'
                      ? 'disabled_inactive_button'
                      : ''
                }>
                Remover
              </Button>
            )}
            <Button
              style={{
                marginLeft: 12,
                color: 'rgba(52, 64, 84, 1)',
                borderRadius: 8,
                background: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(208, 213, 221, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}>
              Cancelar
            </Button>
            <Button
              style={{
                color: 'rgba(255, 255, 255, 1)',
                borderRadius: 8,
                marginLeft: 12,
                background: 'rgba(19, 97, 164, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              type="submit"
              disabled={!isDirty || !isValid}
              className={
                props.channel.deleted === true
                  ? 'disabled_save_button'
                  : props.channel.deleted === 'true'
                    ? 'disabled_save_button'
                    : ''
              }>
              Salvar
            </Button>
          </DialogActions>
          <Modal
            confirmDialogAction={confirmDialogAction}
            setConfirmDialogAction={setConfirmDialogAction}
            isLoadingModalConfirmation={isLoadingModalConfirmation}
            setIsLoadingModalConfirmation={setIsLoadingModalConfirmation}
            showConfirmationButton={showConfirmationButton}
          />
        </Form>
      </Dialog>
    </>
  );
}

export default ModalChannel;
